module.exports = __webpack_public_path__ + "static/media/hand-point-down.763bf3d3.svg";